// Fetches a section's heavy grid (data-url) when it scrolls into view and swaps
// it in by id — keeps below-the-fold grids off the initial server render / TTFB.
class LazySection extends HTMLElement {
  connectedCallback() {
    const url = this.getAttribute('data-url');
    const { id } = this;
    if (!url || !id) return;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.load(url, id);
    }, { rootMargin: '0px 0px 400px 0px' });

    observer.observe(this);
  }

  async load(url, id) {
    try {
      const response = await fetch(url);
      const html = await response.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
      if (fresh?.innerHTML.trim()) {
        this.innerHTML = fresh.innerHTML;
      }
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('lazy-section')) {
  customElements.define('lazy-section', LazySection);
}
